import { useQuery, useQueryClient } from "@tanstack/react-query";
import useKlydoMutation from "../../../components/hooks/useKlydoMutation";
import alertPoliciesClient, {
  AlertPolicyAdmin,
} from "../../../api/alertPolicies";

export type { AlertPolicyAdmin };

// Admins eligible to be added to a policy (only those with a phone number).
export const useEligibleAdmins = () =>
  useQuery({
    queryKey: ["alert-policy-admin-users"],
    queryFn: () => alertPoliciesClient.listAdminUsers(),
  });

export const useSetAdminPhoneMutation = () => {
  const queryClient = useQueryClient();
  return useKlydoMutation({
    mutationKey: ["set-admin-phone"],
    mutationFn: ({
      userId,
      phoneNumber,
    }: {
      userId: string;
      phoneNumber: string | null;
    }) => alertPoliciesClient.setAdminPhone(userId, phoneNumber),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["alert-policy-admin-users"],
      }),
  });
};
